<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M16.5 7.5 7.5 16.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
    <path d="M7.5 7.5 16.5 16.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
  </svg>
</template>
